import { render, staticRenderFns } from "./StartupNews.vue?vue&type=template&id=2bd0a3b0&"
import script from "./StartupNews.vue?vue&type=script&lang=js&"
export * from "./StartupNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports